var scope_0 = require('/Users/julianburr/Documents/dev/scotch-box/public/projects/talk-power-of-toolkits/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/71566a751d9ed13ac124535fcd6cfe4f.js').default;export default
        Object.assign({}, scope_0 )
    